<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="factorymenu_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="h_info">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="h_functions">
                        <ng-container *ngTemplateOutlet="buttons"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">

                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="factory_id" [ttModel]="menu.factory_id" ttReadonly></tt-input>
        <tt-input ttLabel="factory_name" [ttModel]="menu.factory_name" ttReadonly></tt-input>
        <tt-input ttLabel="company_name" [ttModel]="menu.company_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'factorymenu_edit'" [ttGoto]="'factory'" [ttGotoParms]="{ factory_id: menu.factory_id }"></tt-button-goto>
        <tt-button-goto [ttText]="'factorymenu_factorycalendar'" [ttGoto]="'shiftview'" [ttGotoParms]="{ labour_no: 'F' + menu.factory_id }"></tt-button-goto>
        <tt-button-goto [ttText]="'factoringmenu_operationfactories'" [ttGoto]="'operationfactories'" [ttGotoParms]="{ argtype: 'factory_id', argvalue: menu.factory_id }"></tt-button-goto>
        <tt-button-goto [ttText]="'factorymenu_equipmentlist'" [ttGoto]="'equipmentlist'" [ttGotoParms]="{ argtype: 'factory_id', argvalue: menu.factory_id }"></tt-button-goto>
    </ng-container>
</ng-template>
